import { queryOptions } from "@tanstack/react-query";
import { attendanceApi, doorsApi, expenseApi, hrApi, leaveApi, terminalsApi } from "./api.ts";
import { dayRange } from "./time.ts";

// Ключи кадров начинаются с "people": правка отметки меняет и табель, и
// переработку, поэтому после изменения сбрасывается всё разом.
export const PEOPLE = ["people"] as const;

export const employeesQuery = queryOptions({ queryKey: [...PEOPLE, "employees"], queryFn: hrApi.employees });

export const cardNumbersQuery = queryOptions({ queryKey: [...PEOPLE, "card-numbers"], queryFn: hrApi.cardNumbers });

export const shiftsQuery = (day: string) =>
  queryOptions({
    queryKey: [...PEOPLE, "shifts", day],
    queryFn: () => {
      const { from, to } = dayRange(day);
      return attendanceApi.shifts(from, to);
    },
  });

export const overtimeQuery = (employeeId: string, day: string) =>
  queryOptions({ queryKey: [...PEOPLE, "overtime", employeeId, day], queryFn: () => attendanceApi.overtime(employeeId, day) });

export const historyQuery = (id: number) => queryOptions({ queryKey: [...PEOPLE, "history", id], queryFn: () => attendanceApi.history(id) });

export const timesheetQuery = (month: string | undefined) =>
  queryOptions({ queryKey: [...PEOPLE, "timesheet", month ?? "default"], queryFn: () => attendanceApi.timesheet(month) });

export const settingsQuery = queryOptions({ queryKey: [...PEOPLE, "settings"], queryFn: attendanceApi.settings });

export const kiosksQuery = queryOptions({ queryKey: [...PEOPLE, "kiosks"], queryFn: attendanceApi.kiosks });

export const leavesQuery = (employeeId: string) =>
  queryOptions({ queryKey: [...PEOPLE, "leave", employeeId], queryFn: () => leaveApi.list(employeeId) });

export const holidaysQuery = queryOptions({ queryKey: [...PEOPLE, "holidays"], queryFn: leaveApi.holidays });

export const expensesQuery = queryOptions({ queryKey: [...PEOPLE, "expenses"], queryFn: expenseApi.list });

export const accessDaysQuery = (day: string) => queryOptions({ queryKey: [...PEOPLE, "access-days", day], queryFn: () => doorsApi.days(day) });

export const passesQuery = (day: string) => queryOptions({ queryKey: [...PEOPLE, "passes", day], queryFn: () => doorsApi.passes(day) });

export const agentsQuery = queryOptions({ queryKey: [...PEOPLE, "agents"], queryFn: doorsApi.agents });

export const terminalsQuery = queryOptions({ queryKey: [...PEOPLE, "terminals"], queryFn: terminalsApi.devices });

export const workstationsQuery = queryOptions({ queryKey: [...PEOPLE, "workstations"], queryFn: terminalsApi.workstations, staleTime: 5 * 60_000 });

export const sessionsQuery = (day: string) => queryOptions({ queryKey: [...PEOPLE, "sessions", day], queryFn: () => terminalsApi.sessions(day) });

export const lineQuery = queryOptions({ queryKey: [...PEOPLE, "line"], queryFn: terminalsApi.line });
